export const ObjectFilterEmpty = <T = any>(obj: Record<string, T>) => {
  const clone = JSON.parse(JSON.stringify(obj));
  Object.keys(clone).forEach(
    (key) => clone[key] === undefined && delete clone[key],
  );
  return clone;
};
